import {http} from "../http";

export interface Xohks{
    xohks : {
        trnRequestType : string;
        CUSTCIF : string;
        CUSTACC : string;
        PMTCUSTID : string;
        BENEFNAME : string;
        BENEFACC : string;
        BENEFTAXID : string;
        BENEFBANKCODE : string;
        BENEFBANKNAME : string;
        BENEFBANKTAXID : string;
        BENEFBANKCORACC : string;
        BENEFBANKSWIFT : string;
        AMOUNT : number;
        PMTDET : string;
        INFOTOBENEF : string;
        NOTE : string;
        CUSTACCFORCOM : string;
        COMMAMOUNT : string;
    },
    edv: {
        trnRequestType: string;
        PMTCUSTID: string;
        CUSTCIF: string;
        CUSTACC: string;
        AMOUNT: number;
        BENEFNAME: string;
        BENEFACC: string;
        BENEFBANKCODE: string;
        BENEFBANKNAME: string;
        PMTDET: string;
        BENEFTAXID: string;
        INFOTOBENEF: string;
        NOTE: string;
        CUSTACCFORCOM: string;
        COMMAMOUNT : string;
    }
}

export const newMoneyTransferHoks = async (request_data: Xohks): Promise<Xohks> => {
    const { data } = await http.post<Xohks>("moneytransfer/xohks-edv", request_data);
    return data;
};
